import { getEndpointV2 } from 'api';
import { fillPath } from 'helpers/api';

export const getPathToFetchAndAdd = (companyId?: string): string =>
  companyId
    ? fillPath({ path: '/auth/company/:companyId/profile', urlParams: { companyId } })
    : fillPath({ path: '/auth/company/profile' });

export const getUrlToFetchAndAdd = (companyId?: string): string => {
  return getEndpointV2({ path: getPathToFetchAndAdd(companyId) });
};

export const getPathToUpdateAndRemove = (id: string, companyId?: string): string =>
  companyId
    ? fillPath({
        path: '/auth/company/:companyId/profile/:id',
        urlParams: { companyId, id },
      })
    : fillPath({ path: '/auth/company/profile/:id', urlParams: { id } });

export const getUrlToUpdateAndRemove = (id: string, companyId?: string): string => {
  return getEndpointV2({
    path: getPathToUpdateAndRemove(id, companyId),
  });
};
